import React, { useCallback, useEffect, useRef, useState } from "react";
import TextFieldGroup from "../../commons/TextFieldGroup";
import AutocompleteFieldGroup from "../../commons/AutocompleteFieldGroup";
import Searchbar from "../../commons/Searchbar";

import {
  Layout,
  Breadcrumb,
  Form,
  Table,
  Divider,
  Row,
  Col,
  AutoComplete,
  Input,
} from "antd";

import {
  checkboxFormItemLayout,
  formItemLayout,
  smallFormItemLayout,
  tailFormItemLayout,
  threeColumnFormItemLayout,
} from "./../../utils/Layouts";
import { EditOutlined, CloseOutlined, DeleteOutlined } from "@ant-design/icons";
import isEmpty from "../../validation/is-empty";
import { useSelector } from "react-redux";
import {
  edit,
  onDelete,
  onSubmit,
  onSearch,
  onChange,
  onDeleteItem,
} from "../../utils/form_utilities";
import moment from "moment";
import DatePickerFieldGroup from "../../commons/DatePickerFieldGroup";
import numberFormat from "../../utils/numberFormat";
import round from "../../utils/round";
import { authenticateAdmin } from "../../utils/authentications";
import { active_options } from "../../utils/Options";
import SimpleSelectFieldGroup from "../../commons/SimpleSelectFieldGroup";
import CheckboxFieldGroup from "../../commons/CheckboxFieldGroup";
import {
  addKeysToArray,
  onChannelSearch,
  onBranchSearch,
  onCustomerSearch,
} from "../../utils/utilities";
import SelectFieldGroup from "../../commons/SelectFieldGroup";
import RecordButtons from "../../commons/RecordButtons";

import RadioGroupFieldGroup from "../../commons/RadioGroupFieldGroup";
import NumberFieldGroup from "../../commons/NumberFieldGroup";

const { Content } = Layout;

const url = "/api/customers/";
const title = "Customer Form";

const initialValues = {
  _id: null,
  name: "",
  status: "Active",
  address: "",
  address_2: "",
  city: null,
  credit_balance: null,
  debit_memo: null,
  email: "",
  contact_person_1: "",
  contact_person_2: "",
  is_local_supplier: true,
  contact_numbers: [],
  terms: "",
  tin: "",
  created_by: null,
  last_updated_by: null,
  is_individual: true,
  with_labor: true,
  bank_references: [],
  trade_references: [],
};
const date_fields = ["birth_date"];
export default function CustomerForm({ history }) {
  const [errors, setErrors] = useState({});
  const [records, setRecords] = useState([]);
  const [total_records, setTotalRecords] = useState(null);
  const [current_page, setCurrentPage] = useState(1);
  const [search_keyword, setSearchKeyword] = useState("");
  const auth = useSelector((state) => state.auth);
  const [options, setOptions] = useState({
    cities: [],
  });
  const [row_selected, setRowSelected] = useState(null);
  const [contact, setContact] = useState({});
  const contact_number_type_ref = useRef(null);
  const contact_number_ref = useRef(null);

  const [state, setState] = useState(initialValues);

  const records_column = [
    {
      title: "Customer",
      dataIndex: "name",
    },

    {
      title: "Status",
      dataIndex: ["active"],
    },

    /* {
      title: "",
      key: "action",
      width: 10,
      render: (text, record) => (
        <EditOutlined
          onClick={() =>
            edit({
            record,
              setErrors,
              setRecords,
              url,
              setState,
              date_fields,
            })
          }
        />
      ),
    }, */
  ];

  const supplySelectOptions = useCallback(() => {
    onCustomerSearch({ value: "", setOptions });
  }, []);

  useEffect(() => {
    if ((state.bank_references || [])?.length <= 0) {
      setState((prevState) => ({
        ...prevState,
        bank_references: [{}],
      }));
    }

    return () => {};
  }, [state.bank_references]);
  useEffect(() => {
    if ((state.trade_references || [])?.length <= 0) {
      setState((prevState) => ({
        ...prevState,
        trade_references: [{}],
      }));
    }

    return () => {};
  }, [state.trade_references]);

  useEffect(() => {
    supplySelectOptions();

    onSearch({
      page: 1,
      search_keyword,
      url,
      setRecords,
      setTotalRecords,
      setCurrentPage,
      setErrors,
    });
    return () => {};
  }, []);

  useEffect(() => {
    onBranchSearch({ value: "", setOptions });
    authenticateAdmin({
      role: auth.user?.role,
      history,
    });

    return () => {};
  }, []);

  const onNew = useCallback(() => {
    setRecords([]);
    setState(initialValues);
    supplySelectOptions();
  }, []);

  return (
    <Content className="content-padding">
      <div className="columns is-marginless">
        <div className="column">
          <Breadcrumb style={{ margin: "16px 0" }}>
            <Breadcrumb.Item>Home</Breadcrumb.Item>
            <Breadcrumb.Item>{title}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className="column">
          <Searchbar
            name="search_keyword"
            onSearch={(value, e) => {
              e.preventDefault();
              onSearch({
                page: 1,
                search_keyword,
                url,
                setRecords,
                setTotalRecords,
                setCurrentPage,
                setErrors,
              });
            }}
            onChange={(e) => setSearchKeyword(e.target.value)}
            value={search_keyword}
            onNew={() => {
              onNew();
            }}
          />
        </div>
      </div>

      <div style={{ background: "#fff", padding: 24, minHeight: 280 }}>
        <span className="module-title">{title}</span>
        <Divider />
        {isEmpty(records) ? (
          <Form
            onFinish={(values) => {
              onSubmit({
                values: {
                  ...state,
                  credit_limit: round(state.credit_limit),
                  bank_references: state.bank_references.filter(
                    (o) => !isEmpty(o.bank)
                  ),
                  trade_references: state.trade_references.filter(
                    (o) => !isEmpty(o.company)
                  ),
                },
                auth,
                url,
                setErrors,
                setState,
                clear_on_save: true,
                initial_values: { initialValues },
                cb: () => {
                  onSearch({
                    page: 1,
                    search_keyword,
                    url,
                    setRecords,
                    setTotalRecords,
                    setCurrentPage,
                    setErrors,
                  });
                },
              });
            }}
            initialValues={initialValues}
          >
            <Row>
              <Col span={12}>
                <TextFieldGroup
                  label="Customer"
                  name="name"
                  error={errors.name}
                  formItemLayout={smallFormItemLayout}
                  value={state.name}
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.value.toUpperCase(),
                      setState,
                    });
                  }}
                />
              </Col>
              <Col span={12}>
                <TextFieldGroup
                  label="Postal Address"
                  name="postal_address"
                  error={errors.postal_address}
                  formItemLayout={smallFormItemLayout}
                  value={state.postal_address}
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.value.toUpperCase(),
                      setState,
                    });
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col span={12}>
                <TextFieldGroup
                  label="Owner"
                  name="owner"
                  error={errors.owner}
                  formItemLayout={smallFormItemLayout}
                  value={state.owner}
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.value.toUpperCase(),
                      setState,
                    });
                  }}
                />
              </Col>
              <Col span={12}>
                <TextFieldGroup
                  label="Contact Person"
                  name="contact_person"
                  error={errors.contact_person}
                  formItemLayout={smallFormItemLayout}
                  value={state.contact_person}
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.value.toUpperCase(),
                      setState,
                    });
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col span={8}>
                <TextFieldGroup
                  label="Mobile No."
                  name="mobile_no"
                  error={errors.mobile_no}
                  formItemLayout={threeColumnFormItemLayout}
                  value={state.mobile_no}
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.value.toUpperCase(),
                      setState,
                    });
                  }}
                />
              </Col>
              <Col span={8}>
                <TextFieldGroup
                  label="Mobile No. 2"
                  name="mobile_no_2"
                  error={errors.mobile_no_2}
                  formItemLayout={threeColumnFormItemLayout}
                  value={state.mobile_no_2}
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.value.toUpperCase(),
                      setState,
                    });
                  }}
                />
              </Col>
              <Col span={8}>
                <TextFieldGroup
                  label="Landline"
                  name="landline"
                  error={errors.landline}
                  formItemLayout={threeColumnFormItemLayout}
                  value={state.landline}
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.value.toUpperCase(),
                      setState,
                    });
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col span={12}>
                <TextFieldGroup
                  label="Email Address"
                  name="email"
                  error={errors.email}
                  formItemLayout={smallFormItemLayout}
                  value={state.email}
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.value.toUpperCase(),
                      setState,
                    });
                  }}
                />
              </Col>
              <Col span={12}>
                <DatePickerFieldGroup
                  label="Birthdate"
                  name="birth_date"
                  value={state.birth_date}
                  onChange={(value) => {
                    onChange({
                      key: "birth_date",
                      value: value,
                      setState,
                    });
                  }}
                  error={errors.birth_date}
                  formItemLayout={smallFormItemLayout}
                />
              </Col>
            </Row>

            <Row>
              <Col span={12}>
                <NumberFieldGroup
                  label="Credit Limit"
                  name="credit_limit"
                  error={errors.credit_limit}
                  formItemLayout={smallFormItemLayout}
                  value={state.credit_limit}
                  onChange={(value) => {
                    onChange({
                      key: "credit_limit",
                      value,
                      setState,
                    });
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col span={12}>
                <SelectFieldGroup
                  label="Price Level"
                  value={state.price_category?.name}
                  onSearch={(value) =>
                    onPriceCategorySearch({ value, options, setOptions })
                  }
                  onChange={(index) =>
                    setState((prevState) => ({
                      ...prevState,
                      price_category: options.price_categories[index],
                    }))
                  }
                  error={errors.price_category}
                  formItemLayout={smallFormItemLayout}
                  data={options.price_categories}
                  column="name"
                  onAddItem={() =>
                    priceCategoryFormModal.current.open("price_category")
                  }
                />
              </Col>

              <Col span={12}>
                <TextFieldGroup
                  label="Terms"
                  name="terms"
                  error={errors.terms}
                  formItemLayout={smallFormItemLayout}
                  value={state.terms}
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.value,
                      setState,
                    });
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col span={12}>
                <TextFieldGroup
                  label="Remarks"
                  name="remarks"
                  error={errors.remarks}
                  formItemLayout={smallFormItemLayout}
                  value={state.remarks}
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.value,
                      setState,
                    });
                  }}
                />
              </Col>

              <Col span={12}>
                <TextFieldGroup
                  label="TIN"
                  name="tin"
                  error={errors.tin}
                  formItemLayout={formItemLayout}
                  value={state.tin}
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.value,
                      setState,
                    });
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col span={8}>
                <TextFieldGroup
                  label="Last Name"
                  name="last_name"
                  error={errors.last_name}
                  formItemLayout={threeColumnFormItemLayout}
                  value={state.last_name}
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.value.toUpperCase(),
                      setState,
                    });
                  }}
                />
              </Col>
              <Col span={8}>
                <TextFieldGroup
                  label="First Name"
                  name="first_name"
                  error={errors.first_name}
                  formItemLayout={threeColumnFormItemLayout}
                  value={state.first_name}
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.value.toUpperCase(),
                      setState,
                    });
                  }}
                />
              </Col>
              <Col span={8}>
                <TextFieldGroup
                  label="Middle Name"
                  name="middle_name"
                  error={errors.middle_name}
                  formItemLayout={threeColumnFormItemLayout}
                  value={state.middle_name}
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.value.toUpperCase(),
                      setState,
                    });
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col span={8}>
                <TextFieldGroup
                  label="Suffix"
                  name="suffix"
                  error={errors.suffix}
                  formItemLayout={{
                    labelCol: {
                      sm: { span: 12 },
                    },
                    wrapperCol: {
                      sm: { span: 12 },
                    },
                  }}
                  value={state.suffix}
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.value.toUpperCase(),
                      setState,
                    });
                  }}
                />
              </Col>

              <Col span={6}>
                <CheckboxFieldGroup
                  label="Bad Account"
                  name="is_bad_account"
                  error={errors.is_bad_account}
                  formItemLayout={checkboxFormItemLayout}
                  checked={state.is_bad_account}
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.checked,
                      setState,
                    });
                  }}
                />
              </Col>
            </Row>

            <Divider orientation="left">Bank References</Divider>

            <table className="is-full-width">
              <thead>
                <tr>
                  <th>Bank</th>
                  <th>Branch</th>
                  <th>Account No.</th>
                  <th>Type</th>
                  <th>Name of Signatories</th>
                </tr>
              </thead>
              <tbody>
                {(state.bank_references || []).map((o, i) => {
                  return (
                    <tr>
                      <td>
                        <Input
                          name="bank"
                          value={o.bank}
                          onChange={(e) => {
                            const target = e.target;
                            setState((prevState) => {
                              let bank_references = [
                                ...(prevState.bank_references || []),
                              ];

                              if (i === bank_references.length - 1) {
                                bank_references.push({});
                              }

                              bank_references[i][target.name] = target.value;

                              return {
                                ...prevState,
                                bank_references,
                              };
                            });
                          }}
                        />
                      </td>
                      <td>
                        <Input
                          name="branch"
                          value={o.branch}
                          onChange={(e) => {
                            const target = e.target;
                            setState((prevState) => {
                              let bank_references = [
                                ...(prevState.bank_references || []),
                              ];

                              if (i === bank_references.length - 1) {
                                bank_references.push({});
                              }

                              bank_references[i][target.name] = target.value;

                              return {
                                ...prevState,
                                bank_references,
                              };
                            });
                          }}
                        />
                      </td>
                      <td>
                        <Input
                          name="account_no"
                          value={o.account_no}
                          onChange={(e) => {
                            const target = e.target;
                            setState((prevState) => {
                              let bank_references = [
                                ...(prevState.bank_references || []),
                              ];

                              if (i === bank_references.length - 1) {
                                bank_references.push({});
                              }

                              bank_references[i][target.name] = target.value;

                              return {
                                ...prevState,
                                bank_references,
                              };
                            });
                          }}
                        />
                      </td>
                      <td>
                        <Input
                          name="bank_account_type"
                          value={o.bank_account_type}
                          onChange={(e) => {
                            const target = e.target;
                            setState((prevState) => {
                              let bank_references = [
                                ...(prevState.bank_references || []),
                              ];

                              if (i === bank_references.length - 1) {
                                bank_references.push({});
                              }

                              bank_references[i][target.name] = target.value;

                              return {
                                ...prevState,
                                bank_references,
                              };
                            });
                          }}
                        />
                      </td>
                      <td>
                        <Input
                          name="name_of_signatories"
                          value={o.name_of_signatories}
                          onChange={(e) => {
                            const target = e.target;
                            setState((prevState) => {
                              let bank_references = [
                                ...(prevState.bank_references || []),
                              ];

                              if (i === bank_references.length - 1) {
                                bank_references.push({});
                              }

                              bank_references[i][target.name] = target.value;

                              return {
                                ...prevState,
                                bank_references,
                              };
                            });
                          }}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

            <Divider />

            <Row>
              <Col span={12}>
                <SimpleSelectFieldGroup
                  label="Status"
                  name="active"
                  value={state.active}
                  onChange={(value) => {
                    onChange({
                      key: "active",
                      value: value,
                      setState,
                    });
                  }}
                  error={errors.active}
                  formItemLayout={smallFormItemLayout}
                  options={active_options}
                />
              </Col>
              <Col span={12}>
                <Row>
                  <Col span={24}>
                    <TextFieldGroup
                      disabled
                      label="Created By"
                      value={`${state.created_by?.name || ""} / ${
                        state.created_at
                          ? moment(state.created_at).format("MM/DD/YY hh:mm A")
                          : ""
                      }`}
                      formItemLayout={smallFormItemLayout}
                      readOnly
                    />
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <TextFieldGroup
                      disabled
                      label="Updated By"
                      value={`${state.last_updated_by?.name || ""} / ${
                        state.updated_at
                          ? moment(state.updated_at).format("MM/DD/YY hh:mm A")
                          : ""
                      }`}
                      formItemLayout={smallFormItemLayout}
                      readOnly
                    />
                  </Col>
                </Row>
              </Col>
            </Row>

            <Form.Item className="m-t-1" {...tailFormItemLayout}>
              <div className="field is-grouped">
                <div className="control">
                  <button className="button is-small is-primary">Save</button>
                </div>
                {!isEmpty(state._id) ? (
                  <span
                    className="button is-danger is-outlined is-small control"
                    onClick={() => {
                      onDelete({
                        id: state._id,
                        url,
                        user: auth.user,
                      });
                      setState(initialValues);

                      onSearch({
                        page: 1,
                        search_keyword,
                        url,
                        setRecords,
                        setTotalRecords,
                        setCurrentPage,
                        setErrors,
                      });
                    }}
                  >
                    <span>Delete</span>
                    <CloseOutlined />
                  </span>
                ) : null}
                <div className="control">
                  <button
                    className="button is-small is-info"
                    onClick={(e) => {
                      e.preventDefault();
                      onSearch({
                        page: current_page,
                        search_keyword,
                        url,
                        setRecords,
                        setTotalRecords,
                        setCurrentPage,
                        setErrors,
                      });
                    }}
                  >
                    Exit
                  </button>
                </div>
              </div>
            </Form.Item>
          </Form>
        ) : (
          <div>
            <Table
              dataSource={records}
              columns={records_column}
              rowKey={(record) => record._id}
              pagination={{
                current: current_page,
                defaultCurrent: current_page,
                onChange: (page) =>
                  onSearch({
                    page,
                    search_keyword,
                    url,
                    setRecords,
                    setTotalRecords,
                    setCurrentPage,
                    setErrors,
                  }),
                total: total_records,
                pageSize: 10,
              }}
              rowClassName={(record, index) => {
                if (row_selected === index) return "row-is-selected";
              }}
              onRow={(record, index) => {
                return {
                  onClick: (e) => {
                    setRowSelected(index);
                  },
                  onDoubleClick: (e) => {
                    edit({
                      record,
                      setState: (values) => {
                        setState({
                          ...values,
                          bank_references: [
                            ...(values.bank_references || []),
                            {},
                          ],
                          trade_references: [
                            ...(values.trade_references || []),
                            {},
                          ],
                        });
                      },
                      setErrors,
                      setRecords,
                      url,
                      date_fields,
                    });
                  },
                };
              }}
            />
            <RecordButtons
              url={url}
              auth={auth}
              state={records?.[row_selected]}
              onSearch={() => {
                setState(initialValues);
                onSearch({
                  page: current_page,
                  search_keyword,
                  url,
                  setRecords,
                  setTotalRecords,
                  setCurrentPage,
                  setErrors,
                });
              }}
              onNew={() => {
                onNew();
              }}
              has_cancel={false}
            />
          </div>
        )}
      </div>
    </Content>
  );
}
